import {
    FetchAssetInformationByDbIdQuery,
    FetchAssetInformationByIdQuery,
    ResponseAlarmPanel,
    ResponseCommentsPanel,
    ResponseInfoPanel,
    ResponseOfFullAssetInformationModel,
    ResponseSignalsPanel,
    ResponseThreadPanel,
    ResultGetCountEquiposOutput,
    ResultGetIsoPanelOutput,
} from "../Models/AssetInformationModels";
import {
    AddGroupQuery,
    AddSignalsInGroupQuery,
    ChangeChartDatesQuery,
    ChangeChartDefaultDatesQuery,
    ChangeGroupDefaultDatesQuery,
    EditGroupQuery,
    GetChartQuery,
    GetChartsQuery,
    GetGroupQueryNew,
    GetVisionPiUrlInput,
    GetVisionPiUrlOutput,
    ProjectQuery,
    RemoveChartsInGroupQuery,
    RemoveGroupQuery,
    ResponseGetChart,
    ResponseGetCharts,
    ResponseGetGroup,
    ResponseGetGroupsByUser,
    ResponseSignalList,
    ShareGroupQuery,
    UserQuery,
} from "../Models/SignalModels";
import {
    CreateAssetCommand,
    DeleteAssetCommand,
    FilterPanelsInfoCommand,
    FindTheFatherQuery,
    GetAssetQuery,
    GetAssetsDbIdsQuery,
    ListAllTagsQuery,
    ResetAllFilterPanelsInfoCommand,
    ResetFilterPanelsInfoCommand,
    Result,
    ResultOfAPIResponseModel,
    ResultOfAssetControlRulesModel,
    ResultOfAssetsPowerBIReportsModel,
    ResultOfAssetsWithDocuments,
    ResultOfDocumentManagerFullDto,
    ResultOfDocumentsAssetsApiResponse,
    ResultOfExcelColumnsModel,
    ResultOfExcelInfoModel,
    ResultOfExcelPagesModel,
    ResultOfFindTheFatherModel,
    ResultOfForgeAccountFullDto,
    ResultOfForgeObjectDto,
    ResultOfFullAssetInformationModel,
    ResultOfGetAssetModel,
    ResultOfGetAssetsForDbidModel,
    ResultOfIListOfDocumentManagerDto,
    ResultOfIListOfForgeAccountDto,
    ResultOfIListOfForgeObjectDto,
    ResultOfIListOfPowerBIAccountDto,
    ResultOfIListOfProjectDto,
    ResultOfIListOfProjectPowerAppObjectDto,
    ResultOfIListOfRuleSetDto,
    ResultOfIListOfTeamDto,
    ResultOfIReadOnlyCollectionOfCategoryModel,
    ResultOfListAllTagsModel,
    ResultOfListOfAssetInformationModel,
    ResultOfListOfBucketObjectVm,
    ResultOfListOfForgeObjectMaterialDto,
    ResultOfListOfIndexModel,
    ResultOfListOfPanelItemsModel,
    ResultOfListOfPowerBIWorkspaceObjectVm,
    ResultOfListOfPowerBIWorkspaceVm,
    ResultOfListOfProjectPowerBIObjectDto,
    ResultOfListOfString,
    ResultOfPanelItemsModel,
    ResultOfPanelsResponseModel,
    ResultOfPowerBIAccountDto,
    ResultOfProjectDto,
    ResultOfProjectPowerBIObjectDto,
    ResultOfProjectSummaryVm,
    ResultOfRenderViewModel,
    ResultOfRenderViewsModel,
    ResultOfRuleSetDto,
    ResultOfTXTRulesModel,
    ResultOfTeamDto,
    UpdateAssetCommand,
} from "./APIClient";
import {
    GetAssetsDbIdsInput,
    GetAssetsDbIdsOutput,
    GetFilteredPanelQuery,
    InsertFilteredPanelQuery,
    PowerBIRenderQuery,
    ResultOfGetFilteredPanelForUser,
    ResultOfRender2Model,
    SetAssetsCoordinatesInput,
} from "./Interfaces";
import {
    apiPanelsService,
    assetControlService,
    assetEditorService,
    assetsInformationService,
    documentationService,
    forgeService,
    identityService,
    powerAppsService,
    powerBIService,
    projectsService,
    reboteService,
    ruleSetsService,
} from "./Services";
// eslint-disable-next-line import/no-cycle
import {
    TypologyOptionsInput,
    TypologyOptionsOutput,
} from "../BIMDigitalTwin/Project/Viewer/ForgeViewer/Components/Documents/Models/DocumentsModels";
import {
    AddCameraInput,
    AddPlanningVersionInput,
    AddPlanningVersionOutput,
    ConfirmPlanningVersionInput,
    ConfirmPlanningVersionOutput,
    CreatePlanningLineInput,
    DeleteCameraInput,
    DeletePlanningLineInput,
    DownloadPlanningInterferencesInput,
    DownloadPlanningInterferencesOutput,
    GetFileVersionInput,
    GetFileVersionOutput,
    GetPWAProjectsInput,
    GetPWAProjectsOutput,
    GetPlanningInterferencesInput,
    GetPlanningInterferencesOutput,
    GetPlanningLineLogDocumentInput,
    GetPlanningLineLogDocumentOutput,
    GetPlanningLineLogInput,
    GetPlanningLineLogOutput,
    GetPlanningLinesInput,
    GetPlanningTeamsInput,
    GetPlanningTeamsListInput,
    GetPlanningTeamsListOutput,
    GetPlanningTeamsOutput,
    LinkPWAProjectInput,
    ModifyPlanningLineInput,
    SavePlanningTeamsInput,
    SavePlanningTeamsOutput,
    SyncPlanningVersionInput,
    SyncPlanningVersionOutput,
    UpdateInterferencesInput,
    UpdateInterferencesOutput,
} from "../Models/PlanningModel";
import { ResultNavCamera } from "../Models/ProjectModels";
import {
    AddAssetStatusTypeApiInput,
    AddAssetStatusTypeApiOutput,
    AddPlanningVersionAPIOutput,
    AddStatusGroupApiInput,
    AddStatusGroupApiOutput,
    CameraListAPIOutput,
    CreateVideoSettingsApiInput,
    CreateVideoSettingsApiOutput,
    CreateViewApiResponse,
    DeleteAssetStatusTypeApiInput,
    DeleteStatusGroupApiInput,
    DeleteVideoSettingsApiInput,
    DeleteVideoSettingsApiOutput,
    DeleteViewApiInput,
    DeleteViewApiOutput,
    EditStatusGroupApiInput,
    EditVideoSettingsApiInput,
    GetAllPlanningApiFiltersOutput,
    GetFormatsConditionsApiInput,
    GetFormatsConditionsApiOutput,
    GetGanntTasksApiOutput,
    GetGanttInterfaceInput,
    GetPlanningFiltersApiOutput,
    GetPlanningLinesApiOutput,
    GetPlanningTasksInput,
    GetResourcesRenderAPIInput,
    GetResourcesRenderAPIOutput,
    GetStatusAssetTypesApiOutput,
    GetStatusConditionListApiOutput,
    GetStatusGroupApiInput,
    GetStatusGroupApiOutput,
    GetStatusGroupsListApiOutput,
    GetTaksColumnsApiOutput,
    GetTaskColumnsAPIOutput,
    GetTaskDetailsAPIInput,
    GetTaskDetailsAPIOutput,
    GetTaskDetailsByAssetInput,
    GetTaskDetailsByAssetOutput,
    GetTaskStatusApiOutput,
    GetTasksAPIOutput,
    GetVideoRenderAPIInput,
    GetVideoRenderAPIOuput,
    GetVideoSettingsApiInput,
    GetVideoSettingsApiOutput,
    GetVideoSettingsListApiOutput,
    GetViewApiInput,
    GetViewApiOuput,
    GetViewsApiInput,
    GetViewsApiOuput,
    ShareWithUpdateViewApiResponse,
    SyncSAPPLanningByIAPIdOutput,
    UpdateViewApiResponse,
} from "../NewModels/Planning/External/Models";
import {
    AddPlanningVersionInputNew,
    CreateViewInput,
    GetAllPlanningFiltersInput,
    GetPlanningFiltersInput,
    GetTaskColumnsInput,
    GetTaskStatusInput,
    ShareWithUpdateViewInput,
    SyncSAPPLanningByIdInput,
    UpdateViewInput,
} from "../NewModels/Planning/Internal/Models";
import {
    CreateResourceInput,
    CreateTaskInput,
    DeleteTaskInput,
    ExcelToTasksInput,
    GetCategoriesResourcesOutput,
    GetExcelTemplateOutput,
    GetHeatmapBasicInfoListInput,
    GetHeatmapBasicInfoListOutput,
    GetHeatmapDataInput,
    GetHeatmapDataOutput,
    GetRecurrentTasksOutput,
    GetResourcesOutput,
    GetStatusTasksOutput,
    GetTasksInput,
    GetTasksOutput,
    UpdateTaskInput,
} from "../BIMDigitalTwin/Project/Viewer/Components/TasksPlanning/Models";

// Forge
export const fetchForgeAccount = (forgeAccountId: string): Promise<ResultOfForgeAccountFullDto> =>
    forgeService.getAccount(forgeAccountId);
export const fetchAccounts = (): Promise<ResultOfIListOfForgeAccountDto> =>
    forgeService.getAllAccounts();

export const fetchBuckets = (forgeAccountId: string): Promise<ResultOfListOfString> =>
    forgeService.getBuckets(forgeAccountId);
export const fetchBucketObjects = (
    accountId: string,
    bucketId: string
): Promise<ResultOfListOfBucketObjectVm> => forgeService.getBucketObjects(accountId, bucketId);
// export const fetchObjectProperties = (
//     forgeObjectId: string
// ): Promise<ResultOfListOfPropertyCategoryDto> =>
//     forgeService.getPropertiesCategories(forgeObjectId);

export const fetchAPICategories = (
    model: string,
    projectId: string
): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> =>
    assetsInformationService.getCategories(model, projectId);
// export const fetchWorkOrders = (
//     model: string
// ): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> =>
//     assetsInformationService.getCategories(model);

// export const fetchWorkOrders = (date: string): Promise<WorkOrderDto[]> =>
//     assetsInformationService.getWorkOrders(date);

// Project
export const fetchProjects = (): Promise<ResultOfIListOfProjectDto> =>
    projectsService.getProjects();
export const fetchProject = (projectId: string): Promise<ResultOfProjectDto> =>
    projectsService.getProject(projectId);
export const fetchProjectSummary = (projectId: string): Promise<ResultOfProjectSummaryVm> =>
    projectsService.getProjectSummary(projectId);
export const fetchProjectForgeObjects = (
    projectId: string
): Promise<ResultOfIListOfForgeObjectDto> => projectsService.getForgeObjects(projectId);
export const fetchNavCamera = (query: ProjectQuery): Promise<ResultNavCamera> =>
    reboteService.dynamic(
        query.projectId,
        "getNavCamera",
        JSON.stringify(query),
        null
    ) as Promise<ResultNavCamera>;

export const fetchProjectUserDefaultDashboard = (
    projectId: string
): Promise<ResultOfProjectPowerBIObjectDto> =>
    projectsService.getProjectUserDefaultDashboard(projectId);

// Panels
export const fetchPanels = (projectId: string): Promise<ResultOfPanelsResponseModel> =>
    apiPanelsService.getPanels(projectId);

export const fetchFilterPanelsInfo = (
    command: FilterPanelsInfoCommand
): Promise<ResultOfPanelItemsModel> => apiPanelsService.filterPanelsInfo(command);

export const fetchResetFilterPanelsInfo = (
    command: ResetFilterPanelsInfoCommand
): Promise<ResultOfPanelItemsModel> => apiPanelsService.resetFilterPanelsInfo(command);

export const fetchResetAllFilterPanelsInfo = (
    command: ResetAllFilterPanelsInfoCommand
): Promise<ResultOfListOfPanelItemsModel> => apiPanelsService.resetAllFilterPanelsInfo(command);

// Models
export const fetchModels = (projectId: string): Promise<ResultOfIListOfForgeObjectDto> =>
    projectsService.getForgeObjects(projectId);
export const fetchModel = (projectId: string, modelId: string): Promise<ResultOfForgeObjectDto> =>
    projectsService.getForgeObject(projectId, modelId);
export const fetchModelMaterials = (
    forgeObjectId: string
): Promise<ResultOfListOfForgeObjectMaterialDto> => forgeService.getModelMaterials(forgeObjectId);

// // Documentation
export const fetchConnectors = (projectId: string): Promise<ResultOfIListOfDocumentManagerDto> =>
    documentationService.getConnectors(projectId);
export const fetchConnector = (
    projectId: string,
    connectorId: string
): Promise<ResultOfDocumentManagerFullDto> =>
    documentationService.getConnector(connectorId, projectId);
// export const fetchAssetDocumentation = (
//     projectId: string,
//     assetName: string
// ): Promise<DocumentDto[]> => documentationService.getAllDocumentsInAsset(projectId, assetName);

// export const fetchFileDataSources = (projectId: string): Promise<DataSourceFileDto[]> =>
//     dataSourcesService.getFileDataSources(projectId);
// export const fetchFileDataSource = (dataSourceId: string): Promise<DataSourceFileFullDTO> =>
//     dataSourcesService.getFileDataSource(dataSourceId);

// // Aspects
// export const fetchAspects = (): Promise<AspectDto[]> => assetsService.getAspects();
// export const fetchAspect = (aspectId: string): Promise<AspectFullDto> =>
//     assetsService.getAspect(aspectId);

// // AssetTypes
// export const fetchAssetTypes = (): Promise<ResultOfListOfAssetTypeDto> =>
//     assetsService.getAssetTypes();
// export const fetchAssetType = (assetTypeId: string): Promise<ResultOfAssetTypeFullDto> =>
//     assetsService.getAssetType(assetTypeId);
// export const fetchAssetTypeVariables = (
//     assetTypeId: string
// ): Promise<ResultOfAssetTypeVariablesFullDto> => assetsService.getAssetTypeVariables(assetTypeId);

// // Assets
// export const fetchAssets = (projectId: string): Promise<ResultOfListOfAssetDto> =>
//     assetsService.getAssets(projectId);
// export const fetchAsset = (projectId: string, assetName: string): Promise<ResultOfAssetFullDto> =>
//     assetsService.getAsset(projectId, assetName);

// // Work Orders
// export const fetchAllWorkOrders = (projectId: string): Promise<WorkOrderDto[]> =>
//     workOrdersService.getWorkOrders({
//         projectId,
//         firstPlannedDate: "",
//         secondPlannedDate: "",
//     });
// export const fetchWorkOrders = (query: GetWorkOrdersQuery): Promise<WorkOrderDto[]> =>
//     workOrdersService.getWorkOrders(query);
// export const fetchWorkOrder = (workOrderId: string): Promise<WorkOrderDto> =>
//     workOrdersService.getWorkOrder(workOrderId);

// Teams
export const fetchTeams = (projectId: string): Promise<ResultOfIListOfTeamDto> =>
    identityService.getTeams(projectId);
export const fetchTeam = (teamId: string): Promise<ResultOfTeamDto> =>
    identityService.getTeam(teamId);

// export const fetchModelAssetsByExternalId = (
//     projectId: string,
//     forgeObjectId: string,
//     externalId: string
// ): Promise<ResultOfListOfAssetDto> =>
//     assetsService.getModelAssetsByExternalId(projectId, forgeObjectId, externalId);

// export const fetchAssetInfo = (id: string): Promise<ResultOfJsonDocument> =>
//     assetsService.getAssetInfo({ id });

export const fetchAssetInformationOld = (
    projectId: string,
    dbId: number
): Promise<ResultOfFullAssetInformationModel> =>
    assetsInformationService.getAssetInformation(projectId, dbId);

export const fetchAssetInformationByDbId = (
    query: FetchAssetInformationByDbIdQuery
): Promise<ResponseOfFullAssetInformationModel> =>
    reboteService.dynamic(
        query.projectId,
        `getAssetInformation`,
        JSON.stringify(query.input),
        null
    ) as Promise<ResponseOfFullAssetInformationModel>;

export const fetchAssetAndPowerBI = (
    projectId: string
): Promise<ResultOfAssetsPowerBIReportsModel> =>
    assetsInformationService.getAssetsPowerBIReports(projectId);

export const fetchAssetInformationByIdOld = (
    projectId: string,
    id: string
): Promise<ResultOfFullAssetInformationModel> =>
    assetsInformationService.getAssetInformationById(projectId, id);

export const fetchAssetInformationById = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseOfFullAssetInformationModel> =>
    reboteService.dynamic(
        query.projectId,
        `getAssetInformation`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseOfFullAssetInformationModel>;

export const fetchPropertyPanel = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseInfoPanel> =>
    reboteService.dynamic(
        query.projectId,
        `getPropertyPanel`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseInfoPanel>;

export const fetchChatPanel = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseCommentsPanel> =>
    reboteService.dynamic(
        query.projectId,
        `getChatPanel`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseCommentsPanel>;

export const fetchThreadsPanel = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseThreadPanel> =>
    reboteService.dynamic(
        query.projectId,
        `getThreadPanel`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseThreadPanel>;

export const fetchSignalPanel = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseSignalsPanel> =>
    reboteService.dynamic(
        query.projectId,
        `getSignalPanel`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseSignalsPanel>;

export const fetchAlarmPanel = (
    query: FetchAssetInformationByIdQuery
): Promise<ResponseAlarmPanel> =>
    reboteService.dynamic(
        query.projectId,
        `getAlarmPanel`,
        JSON.stringify(query),
        null
    ) as Promise<ResponseAlarmPanel>;

export const fetchAssetsDbIds = (query: GetAssetsDbIdsQuery): Promise<ResultOfListOfIndexModel> =>
    assetsInformationService.getAssetsDbIds(query);

export const getAssetsDbIds = (query: GetAssetsDbIdsInput): Promise<GetAssetsDbIdsOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getAssetsDbIds`,
        JSON.stringify(query.input),
        null
    ) as Promise<GetAssetsDbIdsOutput>;

export const setAssetsCoordinates = (query: SetAssetsCoordinatesInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `setAssetsCoordinates`,
        JSON.stringify(query.input),
        null
    ) as Promise<Result>;

export const fetchAllAssetInformation = (projectId: string): Promise<ResultOfListOfIndexModel> =>
    assetsInformationService.getAllAssets({
        projectId,
    });

export const fetchWorkOrders = (plannedDate: Date): Promise<ResultOfAPIResponseModel> =>
    assetsInformationService.getWorkOrders(plannedDate);

export const fetchPermitsToWork = (
    projectId: string,
    date?: Date | undefined
): Promise<ResultOfAPIResponseModel> =>
    assetsInformationService.getPermitsToWork({ projectId, date });

export const fetchAssetsForDbid = (
    projectId: string | null | undefined,
    dbId: number | undefined
): Promise<ResultOfGetAssetsForDbidModel> =>
    assetsInformationService.getAssetsForDbid(projectId, dbId);

// PowerBI
export const fetchPowerBIAccount = (powerBIAccountId: string): Promise<ResultOfPowerBIAccountDto> =>
    powerBIService.getAccount(powerBIAccountId);
export const fetchPowerBIAccounts = (): Promise<ResultOfIListOfPowerBIAccountDto> =>
    powerBIService.getAllAccounts();
export const fetchPowerBIObjects = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIObjects(projectId);
export const fetchPowerBIWorkspaces = (
    powerBIAccountId: string
): Promise<ResultOfListOfPowerBIWorkspaceVm> => powerBIService.getWorkspaces(powerBIAccountId);
export const fetchPowerBIWorkspaceObjects = (
    powerBIAccountId: string,
    workspaceId: string
): Promise<ResultOfListOfPowerBIWorkspaceObjectVm> =>
    powerBIService.getWorkspaceObjects(powerBIAccountId, workspaceId);
export const fetchPowerBIReports = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIReports(projectId);
export const fetchPowerBIDashboards = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIDashboards(projectId);

// Rules
export const fetchPowerBIObjectRuleSets = (
    powerBIObjectId: string
): Promise<ResultOfIListOfRuleSetDto> =>
    ruleSetsService.getPowerBIObjectRuleSets({ ruleSetObjectId: powerBIObjectId });

export const fetchWorkOrdersRuleSet = (ruleSetId: string): Promise<ResultOfRuleSetDto> =>
    ruleSetsService.getRuleSet(ruleSetId);

export const fetchHeatMap = (
    projectId: string,
    date: string | null
): Promise<ResultOfListOfAssetInformationModel> =>
    assetsInformationService.getHeatMap(projectId, date);
export const fetchMonthsWithMeasurements = (projectId: string): Promise<ResultOfListOfString> =>
    assetsInformationService.getMonthsWithMeasurements(projectId);

export const fetchHeatMapByMonth = (
    projectId: string,
    year: string | null,
    month: string | null
): Promise<ResultOfListOfAssetInformationModel> =>
    assetsInformationService.getHeatMapByMonth(projectId, year, month);

export const fetchDatesWithMeasurements = (projectId: string): Promise<ResultOfListOfString> =>
    assetsInformationService.getDatesWithMeasurements(projectId);

export const fetchAllDocuments = (projectId: string): Promise<ResultOfDocumentsAssetsApiResponse> =>
    documentationService.getAllProjectDocuments(projectId);

export const fetchDocumentsByTagApi = (
    projectId: string,
    tag: string | null
): Promise<ResultOfDocumentsAssetsApiResponse> =>
    documentationService.getDocumentsByTagApi(projectId, tag);

export const fetchAvailableAssetControls = (
    projectId: string
): Promise<ResultOfAssetControlRulesModel> =>
    assetControlService.getAvailableAssetControls(projectId);

export const fetchAllAssetControlViews = (projectId: string): Promise<ResultOfRenderViewsModel> =>
    assetControlService.getAllAssetControlViewsRender(projectId);

export const fetchExcelInfo = (
    projectId: string,
    blobName: string | null
): Promise<ResultOfExcelInfoModel> => assetControlService.getExcelInfo(projectId, blobName);

export const fetchAssetsWithDocuments = (projectId: string): Promise<ResultOfAssetsWithDocuments> =>
    assetsInformationService.getAssetsWithDocuments(projectId);

export const fetchAssetControl = (
    projectId: string,
    viewId: string
): Promise<ResultOfRenderViewModel> =>
    assetControlService.renderAssetControlView(projectId, viewId);

// #region PowerApps
export const fetchPowerApps = (
    projectId: string
): Promise<ResultOfIListOfProjectPowerAppObjectDto> => powerAppsService.getPowerApps(projectId);

export const fetchPowerAppsObjects = (
    projectId: string
): Promise<ResultOfIListOfProjectPowerAppObjectDto> => powerAppsService.getPowerApps(projectId);

// Asset Control
export const fetchAssetControlDocumentList = (
    projectId: string | null
): Promise<ResultOfListOfString> => assetControlService.getFileNames(projectId);

export const fetchExcelPages = (
    projectId: string | null,
    fileName: string | null
): Promise<ResultOfExcelPagesModel> => assetControlService.getExcelPages(projectId, fileName);

export const fetchExcelColumns = (
    projectId: string | null,
    fileName: string | null,
    page: string | null
): Promise<ResultOfExcelColumnsModel> =>
    assetControlService.getExcelColumns(projectId, fileName, page);

export const fetchTXTRulesByVista = (
    projectId: string | null,
    idVista: string | null
): Promise<ResultOfTXTRulesModel> => assetControlService.getTXTRulesByVista(projectId, idVista);

// Signals
export const addGroup = (query: AddGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "addGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId, userId: query.userId }),
        null
    ) as Promise<Result>;

// old getSignals
export const fetchCharts = (query: GetChartsQuery): Promise<ResponseGetCharts> =>
    reboteService.dynamic(
        query.projectId,
        "getCharts",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<ResponseGetCharts>;

export const fetchGroups = (query: UserQuery): Promise<ResponseGetGroupsByUser> =>
    reboteService.dynamic(
        query.projectId,
        "getGroupsByUser",
        JSON.stringify(query),
        null
    ) as Promise<ResponseGetGroupsByUser>;

export const fetchSignalList = (query: ProjectQuery): Promise<ResponseSignalList> =>
    reboteService.dynamic(
        query.projectId,
        "getSignalList",
        JSON.stringify(query),
        null
    ) as Promise<ResponseSignalList>;

export const changeGroupDefaultDates = (query: ChangeGroupDefaultDatesQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "changeGroupDefaultDates",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<Result>;

// cambiado nombre a CHART
export const changeChartDefaultDates = (query: ChangeChartDefaultDatesQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "changeChartDefaultDates",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<Result>;

export const fetchGroup = (query: GetGroupQueryNew): Promise<ResponseGetGroup> =>
    reboteService.dynamic(
        query.projectId,
        "getGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId, userId: query.userId }),
        null
    ) as Promise<ResponseGetGroup>;

export const addSignalsInGroup = (query: AddSignalsInGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "addSignalInGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<Result>;

export const removeGroup = (query: RemoveGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "removeGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId, userId: query.userId }),
        null
    ) as Promise<Result>;

// cambiado nombre a CHART
export const changeChartDates = (query: ChangeChartDatesQuery): Promise<ResponseGetChart> =>
    reboteService.dynamic(
        query.projectId,
        "changeChartDefaultDates",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<ResponseGetChart>;

// cambiado nombre a CHART GetSignal
export const fetchChart = (query: GetChartQuery): Promise<ResponseGetChart> =>
    reboteService.dynamic(
        query.projectId,
        "getChart",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<ResponseGetChart>;

// antes era RemoveSignalInGroup
export const removeChartsInGroup = (query: RemoveChartsInGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "removeChartInGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<Result>;

export const editGroup = (query: EditGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "editGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId }),
        null
    ) as Promise<Result>;

export const shareGroup = (query: ShareGroupQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "shareGroup",
        JSON.stringify({ ...query.input, projectId: query.projectId, userId: query.userId }),
        null
    ) as Promise<Result>;

// Edit Asset
export const fetchTheFather = (query: FindTheFatherQuery): Promise<ResultOfFindTheFatherModel> =>
    assetEditorService.findTheFather(query);

export const createAsset = (command: CreateAssetCommand): Promise<Result> =>
    assetEditorService.createAsset(command);

export const fetchAssetToEdit = (query: GetAssetQuery): Promise<ResultOfGetAssetModel> =>
    assetEditorService.getAsset(query);

export const updateAsset = (command: UpdateAssetCommand): Promise<Result> =>
    assetEditorService.updateAsset(command);

export const deleteAsset = (command: DeleteAssetCommand): Promise<Result> =>
    assetEditorService.deleteAsset(command);

export const fetchAllTags = (query: ListAllTagsQuery): Promise<ResultOfListAllTagsModel> =>
    assetEditorService.listAllTags(query);

// Power BI Render
export const fetchPowerBIRender = (input: PowerBIRenderQuery): Promise<ResultOfRender2Model> =>
    reboteService.dynamic(
        input.projectId,
        "getPowerBIRender",
        JSON.stringify(input.input),
        null
    ) as Promise<ResultOfRender2Model>;

export const insertFilteredPanelForUser = (query: InsertFilteredPanelQuery): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        "insertFilteredPanelForUser",
        JSON.stringify({
            ...query.input,
            userId: query.userId,
            projectId: query.projectId,
        }),
        null
    ) as Promise<Result>;

export const getFilteredPanelForUser = (
    query: GetFilteredPanelQuery
): Promise<ResultOfGetFilteredPanelForUser> =>
    reboteService.dynamic(
        query.projectId,
        "getFilteredPanelforUser",
        JSON.stringify({
            ...query.input,
            userId: query.userId,
            projectId: query.projectId,
        }),
        null
    ) as Promise<ResultOfGetFilteredPanelForUser>;

// Panel de control

export const fetchGetCountEquipos = (query: ProjectQuery): Promise<ResultGetCountEquiposOutput> =>
    reboteService.dynamic(
        query.projectId,
        "getCountEquipos",
        JSON.stringify(query),
        null
    ) as Promise<ResultGetCountEquiposOutput>;

export const fetchIsoPanel = (query: ProjectQuery): Promise<ResultGetIsoPanelOutput> =>
    reboteService.dynamic(
        query.projectId,
        "getIsoPanel",
        JSON.stringify(query),
        null
    ) as Promise<ResultGetIsoPanelOutput>;

// Módulo de planificación

export const createPlanningLine = (command: CreatePlanningLineInput): Promise<Result> =>
    reboteService.dynamic(
        command.projectId,
        `createPlanningLine`,
        JSON.stringify(command.input),
        null
    ) as Promise<Result>;

export const deletePlanningLine = (command: DeletePlanningLineInput): Promise<Result> =>
    reboteService.dynamic(
        command.projectId,
        `deletePlanningLine`,
        JSON.stringify(command.input),
        null
    ) as Promise<Result>;

export const modifyPlanningLine = (command: ModifyPlanningLineInput): Promise<Result> =>
    reboteService.dynamic(
        command.projectId,
        `modifyPlanningLine`,
        JSON.stringify(command.input),
        null
    ) as Promise<Result>;

export const getPlanningLines = (
    query: GetPlanningLinesInput
): Promise<GetPlanningLinesApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPlanningLines`,
        JSON.stringify(query),
        null
    ) as Promise<GetPlanningLinesApiOutput>;

export const addPlanningVersion = (
    command: AddPlanningVersionInput
): Promise<AddPlanningVersionOutput> =>
    reboteService.dynamic(
        command.projectId,
        `addPlanningVersion`,
        JSON.stringify(command.input),
        null
    ) as Promise<AddPlanningVersionOutput>;

export const confirmPlanningVersion = (
    command: ConfirmPlanningVersionInput
): Promise<ConfirmPlanningVersionOutput> =>
    reboteService.dynamic(
        command.projectId,
        `confirmPlanningVersion`,
        JSON.stringify(command.input),
        null
    ) as Promise<ConfirmPlanningVersionOutput>;

export const getFileVersion = (command: GetFileVersionInput): Promise<GetFileVersionOutput> =>
    reboteService.dynamic(
        command.projectId,
        `getFileVersion`,
        JSON.stringify(command.input),
        null
    ) as Promise<GetFileVersionOutput>;

export const syncPlanningVersion = (
    command: SyncPlanningVersionInput
): Promise<SyncPlanningVersionOutput> =>
    reboteService.dynamic(
        command.projectId,
        `syncPlanningVersion`,
        JSON.stringify(command.input),
        null
    ) as Promise<SyncPlanningVersionOutput>;

export const getPWAProjects = (query: GetPWAProjectsInput): Promise<GetPWAProjectsOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getProjectsFromPWA`,
        JSON.stringify(query.input),
        null
    ) as Promise<GetPWAProjectsOutput>;

export const linkPWAProject = (command: LinkPWAProjectInput): Promise<Result> =>
    reboteService.dynamic(
        command.projectId,
        `linkPWAProject`,
        JSON.stringify(command.input),
        null
    ) as Promise<Result>;

export const getPlanningLineLog = (
    query: GetPlanningLineLogInput
): Promise<GetPlanningLineLogOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPlanningLineLog`,
        JSON.stringify(query.input),
        null
    ) as Promise<GetPlanningLineLogOutput>;

export const getPlanningLineLogDocument = (
    query: GetPlanningLineLogDocumentInput
): Promise<GetPlanningLineLogDocumentOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getDetailedLogs`,
        JSON.stringify(query.input),
        null
    ) as Promise<GetPlanningLineLogDocumentOutput>;

export const addCamera = ({ projectId, input }: AddCameraInput): Promise<Result> =>
    reboteService.dynamic(
        projectId,
        `addCamera`,
        JSON.stringify({ ...input, projectId }),
        null
    ) as Promise<Result>;

export const getCameras = (query: ProjectQuery): Promise<CameraListAPIOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getCameras`,
        JSON.stringify(query),
        null
    ) as Promise<CameraListAPIOutput>;

export const deleteCamera = (query: DeleteCameraInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `deleteCamera`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const getVideoRender = (query: GetVideoRenderAPIInput): Promise<GetVideoRenderAPIOuput> =>
    reboteService.dynamic(
        query.projectId,
        `getVideoRender`,
        JSON.stringify(query),
        null
    ) as Promise<GetVideoRenderAPIOuput>;

export const getPlanningTasks = (
    query: GetPlanningTasksInput,
    signal: AbortSignal | undefined
): Promise<GetTasksAPIOutput> => {
    const inputJson = JSON.stringify(query);
    return reboteService.dynamic(
        query.projectId,
        "getTasks",
        inputJson,
        null,
        signal
    ) as Promise<GetTasksAPIOutput>;
};

export const getPlanningInterferences = (
    query: GetPlanningInterferencesInput
): Promise<GetPlanningInterferencesOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getInterferences`,
        JSON.stringify(query),
        null
    ) as Promise<GetPlanningInterferencesOutput>;

export const updatePlanningInterferences = (
    query: UpdateInterferencesInput
): Promise<UpdateInterferencesOutput> =>
    reboteService.dynamic(
        query.projectId,
        `updateInterferences`,
        JSON.stringify(query.input),
        null
    ) as Promise<UpdateInterferencesOutput>;

export const downloadPlanningInterferences = (
    query: DownloadPlanningInterferencesInput
): Promise<DownloadPlanningInterferencesOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getInterferenceReport`,
        JSON.stringify(query.input),
        null
    ) as Promise<DownloadPlanningInterferencesOutput>;

export const getPlanningGanntTasks = (
    query: GetGanttInterfaceInput
): Promise<GetGanntTasksApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTasksGantt`,
        JSON.stringify(query),
        null
    ) as Promise<GetGanntTasksApiOutput>;

export const getTasksWithAllColumnsFetch = (
    query: GetGanttInterfaceInput
): Promise<GetTaksColumnsApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTasksAllColumns `,
        JSON.stringify(query),
        null
    ) as Promise<GetTaksColumnsApiOutput>;

export const getPlanningTasksDetails = (
    query: GetTaskDetailsAPIInput
): Promise<GetTaskDetailsAPIOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPanelTask`,
        JSON.stringify(query),
        null
    ) as Promise<GetTaskDetailsAPIOutput>;

export const getPlanningTasksDetailsByDbid = (
    query: GetTaskDetailsByAssetInput
): Promise<GetTaskDetailsByAssetOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTasksByDbId`,
        JSON.stringify(query),
        null
    ) as Promise<GetTaskDetailsByAssetOutput>;

// export const generateVideoImages = (
//     query: GenerateVideoImagesAPIInput
// ): Promise<GenerateVideoImagesAPIOutput> =>
//     reboteService.dynamic(
//         query.projectId,
//         `generateVideoImages`,
//         JSON.stringify(query.input),
//         null
//     ) as Promise<GenerateVideoImagesAPIOutput>;

export const getTaskColumns = (query: GetTaskColumnsInput): Promise<GetTaskColumnsAPIOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTaskColumns`,
        JSON.stringify(query),
        null
    ) as Promise<GetTaskColumnsAPIOutput>;

export const addPlanningVersionNew = (
    query: AddPlanningVersionInputNew
): Promise<AddPlanningVersionAPIOutput> =>
    reboteService.dynamic(
        query.projectId,
        `addPlanningVersion`,
        JSON.stringify(query),
        null
    ) as Promise<AddPlanningVersionAPIOutput>;

export const syncSAPPlanningById = (
    query: SyncSAPPLanningByIdInput
): Promise<SyncSAPPLanningByIAPIdOutput> =>
    reboteService.dynamic(
        query.projectId,
        `addPlanningVersion`,
        JSON.stringify(query),
        null
    ) as Promise<SyncSAPPLanningByIAPIdOutput>;

export const getAllPlanningFilters = (
    query: GetAllPlanningFiltersInput
): Promise<GetAllPlanningApiFiltersOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getAllPlanningFilters`,
        JSON.stringify(query),
        null
    ) as Promise<GetAllPlanningApiFiltersOutput>;

export const getPlanningFilters = (
    query: GetPlanningFiltersInput
): Promise<GetPlanningFiltersApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPlanningFilters`,
        JSON.stringify(query),
        null
    ) as Promise<GetPlanningFiltersApiOutput>;

export const getView = (
    query: GetViewApiInput,
    signal?: AbortSignal | undefined
): Promise<GetViewApiOuput> =>
    reboteService.dynamic(
        query.projectId,
        `getView`,
        JSON.stringify(query),
        null,
        signal
    ) as Promise<GetViewApiOuput>;

export const getResourcesRender = (
    query: GetResourcesRenderAPIInput
): Promise<GetResourcesRenderAPIOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getResourcesRender`,
        JSON.stringify(query),
        null
    ) as Promise<GetResourcesRenderAPIOutput>;

export const getViews = (query: GetViewsApiInput): Promise<GetViewsApiOuput> =>
    reboteService.dynamic(
        query.projectId,
        `getViews`,
        JSON.stringify(query),
        null
    ) as Promise<GetViewsApiOuput>;

export const updateView = (query: UpdateViewInput): Promise<UpdateViewApiResponse> =>
    reboteService.dynamic(
        query.projectId,
        `updateView`,
        JSON.stringify(query),
        null
    ) as Promise<UpdateViewApiResponse>;

export const shareWithUpdateView = (
    query: ShareWithUpdateViewInput
): Promise<ShareWithUpdateViewApiResponse> =>
    reboteService.dynamic(
        query.projectId,
        `sharedWithUpdateView`,
        JSON.stringify(query),
        null
    ) as Promise<UpdateViewApiResponse>;

export const getFormatsConditions = (
    query: GetFormatsConditionsApiInput
): Promise<GetFormatsConditionsApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getFormatsConditions`,
        JSON.stringify(query),
        null
    ) as Promise<GetFormatsConditionsApiOutput>;

export const deleteView = (query: DeleteViewApiInput): Promise<DeleteViewApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `deleteView`,
        JSON.stringify(query),
        null
    ) as Promise<DeleteViewApiOutput>;

export const createView = (query: CreateViewInput): Promise<CreateViewApiResponse> =>
    reboteService.dynamic(
        query.projectId,
        `createView`,
        JSON.stringify(query),
        null
    ) as Promise<CreateViewApiResponse>;

// #region STATUS

export const editStatusGroup = (query: EditStatusGroupApiInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `editStatusGroup`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const addStatusGroup = (query: AddStatusGroupApiInput): Promise<AddStatusGroupApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `addStatusGroup`,
        JSON.stringify(query),
        null
    ) as Promise<AddStatusGroupApiOutput>;

export const deleteStatusGroup = (query: DeleteStatusGroupApiInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `deleteStatusGroup`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const getStatusGroupsList = (query: ProjectQuery): Promise<GetStatusGroupsListApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getStatusGroupsList`,
        JSON.stringify(query),
        null
    ) as Promise<GetStatusGroupsListApiOutput>;

export const getStatusGroup = (query: GetStatusGroupApiInput): Promise<GetStatusGroupApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getStatusGroup`,
        JSON.stringify(query),
        null
    ) as Promise<GetStatusGroupApiOutput>;

export const getStatusConditionList = (
    query: ProjectQuery
): Promise<GetStatusConditionListApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getStatusConditionList`,
        JSON.stringify(query),
        null
    ) as Promise<GetStatusConditionListApiOutput>;

export const getStatusAssetTypes = (query: ProjectQuery): Promise<GetStatusAssetTypesApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getStatusAssetTypes`,
        JSON.stringify(query),
        null
    ) as Promise<GetStatusAssetTypesApiOutput>;

export const deleteAssetStatusType = (query: DeleteAssetStatusTypeApiInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `deleteAssetStatusType`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const addAssetStatusType = (
    query: AddAssetStatusTypeApiInput
): Promise<AddAssetStatusTypeApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `addAssetStatusType`,
        JSON.stringify(query),
        null
    ) as Promise<AddAssetStatusTypeApiOutput>;

export const getTaskStatus = (query: GetTaskStatusInput): Promise<GetTaskStatusApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTaskStatus`,
        JSON.stringify(query),
        null
    ) as Promise<GetTaskStatusApiOutput>;

// vision pi

export const getVisionPiUrl = (query: GetVisionPiUrlInput): Promise<GetVisionPiUrlOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getVisionPiUrl`,
        JSON.stringify(query.input),
        null
    ) as Promise<GetVisionPiUrlOutput>;

// #region video Settings

export const deleteVideoSettings = (
    query: DeleteVideoSettingsApiInput
): Promise<DeleteVideoSettingsApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `deleteVideoSettings`,
        JSON.stringify(query),
        null
    ) as Promise<DeleteVideoSettingsApiOutput>;

export const editVideoSettings = (query: EditVideoSettingsApiInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `editVideoSettings`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const createVideoSettings = (
    query: CreateVideoSettingsApiInput
): Promise<CreateVideoSettingsApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `createVideoSettings`,
        JSON.stringify(query),
        null
    ) as Promise<CreateVideoSettingsApiOutput>;

export const getVideoSettings = (
    query: GetVideoSettingsApiInput
): Promise<GetVideoSettingsApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getVideoSettings`,
        JSON.stringify(query),
        null
    ) as Promise<GetVideoSettingsApiOutput>;

export const getVideoSettingsList = (query: UserQuery): Promise<GetVideoSettingsListApiOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getVideoSettingsList`,
        JSON.stringify(query),
        null
    ) as Promise<GetVideoSettingsListApiOutput>;

export const getTypologyOptions = (query: TypologyOptionsInput): Promise<TypologyOptionsOutput> =>
    reboteService.dynamic(
        query.projectId,
        `typologyOptions`,
        JSON.stringify({}),
        null
    ) as Promise<TypologyOptionsOutput>;

// #region Planning teams

export const getPlanningTeamsList = (
    query: GetPlanningTeamsListInput
): Promise<GetPlanningTeamsListOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPlanningTeamsList`,
        JSON.stringify(query),
        null
    ) as Promise<GetPlanningTeamsListOutput>;

export const getPlanningTeams = (query: GetPlanningTeamsInput): Promise<GetPlanningTeamsOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getPlanningTeams`,
        JSON.stringify(query),
        null
    ) as Promise<GetPlanningTeamsOutput>;

export const savePlanningTeams = (
    query: SavePlanningTeamsInput
): Promise<SavePlanningTeamsOutput> =>
    reboteService.dynamic(
        query.projectId,
        `savePlanningTeams`,
        JSON.stringify(query.input),
        null
    ) as Promise<SavePlanningTeamsOutput>;

// #endregion

// #region Tasks

export const getTasks = (query: GetTasksInput): Promise<GetTasksOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getTasks`,
        JSON.stringify(query),
        null
    ) as Promise<GetTasksOutput>;

export const getRecurrentTasks = (query: ProjectQuery): Promise<GetRecurrentTasksOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getRecurrentTasks`,
        JSON.stringify(query),
        null
    ) as Promise<GetRecurrentTasksOutput>;

export const createTask = (query: CreateTaskInput): Promise<Result> =>
    reboteService.dynamic(
        query.data.projectId,
        `createTask`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const updateTask = (query: UpdateTaskInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `updateTask`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const deleteTask = (query: DeleteTaskInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `deleteTask`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const deleteRecurrentTask = (query: DeleteTaskInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `deleteRecurrentTask`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const createResource = (query: CreateResourceInput): Promise<Result> =>
    reboteService.dynamic(
        query.data.projectId,
        `createResource`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const getResources = (query: ProjectQuery): Promise<GetResourcesOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getResources`,
        JSON.stringify(query),
        null
    ) as Promise<GetResourcesOutput>;

export const getCategoriesResources = (
    query: ProjectQuery
): Promise<GetCategoriesResourcesOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getCategory`,
        JSON.stringify(query),
        null
    ) as Promise<GetCategoriesResourcesOutput>;

export const getStatusTasks = (query: ProjectQuery): Promise<GetStatusTasksOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getStatus`,
        JSON.stringify(query),
        null
    ) as Promise<GetStatusTasksOutput>;

export const getExcelTemplate = (query: ProjectQuery): Promise<GetExcelTemplateOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getExcelTemplate`,
        JSON.stringify(query),
        null
    ) as Promise<GetExcelTemplateOutput>;

export const excelToTasks = (query: ExcelToTasksInput): Promise<Result> =>
    reboteService.dynamic(
        query.projectId,
        `excelToTasks`,
        JSON.stringify(query),
        null
    ) as Promise<Result>;

export const getHeatmapBasicInfoList = (
    query: GetHeatmapBasicInfoListInput
): Promise<GetHeatmapBasicInfoListOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getHeatmapsBasicInfo`,
        JSON.stringify(query),
        null
    ) as Promise<GetHeatmapBasicInfoListOutput>;

export const getHeatmapData = (query: GetHeatmapDataInput): Promise<GetHeatmapDataOutput> =>
    reboteService.dynamic(
        query.projectId,
        `getHeatmap`,
        JSON.stringify(query),
        null
    ) as Promise<GetHeatmapDataOutput>;
